import { useContext } from 'react';
import { ChatContext } from '../../components/ChatProvider';

export default function useDCXChatContext() {
  //console.log("DCX ChatContext::");
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useDCXChatContext. must be used within a ChatProvider');
  }
  return context;
}
